import { useEffect } from "react";

import { useNavigate } from "react-router";

import { useNavigationStore } from "@/stores/useNavigationStore";

const RedirectHandler = () => {
  const navigate = useNavigate();
  const redirectRoute = useNavigationStore(state => state.redirectRoute);
  const setRedirectRoute = useNavigationStore(state => state.setRedirectRoute);

  useEffect(() => {
    if (!redirectRoute) return;
    navigate(redirectRoute, { replace: true });
    setRedirectRoute(null); // clear so it doesn't re-fire
  }, [redirectRoute, navigate, setRedirectRoute]);

  return null;
};

export default RedirectHandler;
